// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hy-0";